var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.364,
    height: 15,
    viewBox: "0 0 16.364 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "enveloppe_1_",
    "data-name": "enveloppe (1)",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2635",
    "data-name": "Trac\\xE9 2635",
    d: "M16.332,5.542l-5.74,5.74a3.414,3.414,0,0,1-4.822,0L.031,5.542C.022,5.65,0,5.747,0,5.854v8.182a3.413,3.413,0,0,0,3.409,3.409h9.545a3.413,3.413,0,0,0,3.409-3.409V5.854C16.364,5.747,16.342,5.65,16.332,5.542Z",
    transform: "translate(0 -1.445)",
    fill: "#165227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2636",
    "data-name": "Trac\\xE9 2636",
    d: "M9.865,8.872l6.228-6.228A3.4,3.4,0,0,0,13.191,1H3.646a3.4,3.4,0,0,0-2.9,1.644L6.972,8.872a2.05,2.05,0,0,0,2.894,0Z",
    transform: "translate(-0.237)",
    fill: "#165227"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4286b990e09c540f58edceb2e0ce2975.svg";
export { ForwardRef as ReactComponent };